import { render, staticRenderFns } from "./MotorDocumentUploadPanel.vue?vue&type=template&id=10d6d2fb&scoped=true"
import script from "./MotorDocumentUploadPanel.vue?vue&type=script&lang=js"
export * from "./MotorDocumentUploadPanel.vue?vue&type=script&lang=js"
import style0 from "./MotorDocumentUploadPanel.vue?vue&type=style&index=0&id=10d6d2fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6d2fb",
  null
  
)

export default component.exports